import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';
interface IProps {
	post: IPost;
}

const formatDate = (dateString: string): string => {
	const date = new Date(dateString);
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const year = date.getFullYear();
	return `${month}/${day}/${year}`;
};

const sanitizeOptions = {
	allowedTags: ['mark'],
	allowedAttributes: {
		mark: ['class'],
	},
};

const SearchResult = ({ post }: IProps) => {
	const target = post.external_url ? `_blank` : `_self`;
	const rel = post.external_url ? `noreferrer noopener` : `noreferrer`;

	return (
		<div className={`pfa-card-wrapper pfa-card-wrapper--${post.post_type}`}>
			<a href={post.permalink} target={target} rel={rel} className="pfa-card-search">
				<div className="pfa-card-search__header">
					{post.post_type_label && (
						<div className="pfa-card-search__tag-container">
							<p className="pfa-card-search__tag post-tag">{post.post_type_label}</p>
						</div>
					)}
					{post.post_date && (
						<p className="pfa-card-search__date">{formatDate(post.post_date)}</p>
					)}
				</div>

				<div className="pfa-card-search__content">
					{post.post_title && (
						<h3
							className="pfa-card-search__title"
							dangerouslySetInnerHTML={{
								__html: sanitizeHtml(post.post_title, sanitizeOptions),
							}}
						/>
					)}
					{post.post_excerpt && (
						<p
							className="pfa-card-search__excerpt"
							dangerouslySetInnerHTML={{
								__html: sanitizeHtml(post.post_excerpt, sanitizeOptions),
							}}
						/>
					)}
					{post.site_title && (
						<p className="pfa-card-search__site-title">{post.site_title}</p>
					)}
				</div>
			</a>
		</div>
	);
};

SearchResult.displayName = 'SearchResult';

export default SearchResult;
